import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { NOTIFICATION_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const notificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: NOTIFICATION_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  tagTypes: [
    "GetNotifications",
    "GetNotificationsStatus",
    "GetNotificationSetting",
    "GetNotificationTemplates",
    "GetNotificationTemplatesDetails",
  ],
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
